import { render, staticRenderFns } from "./EnacAtplDashboardFilesTable.vue?vue&type=template&id=0c064790"
import script from "./EnacAtplDashboardFilesTable.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports